// `/i#<jeton>` : le lien personnel. Le jeton est gardé sur l'appareil, puis
// retiré de l'adresse (il ne reste ni dans l'historique ni dans une capture).
// Lien coupé : pas d'impasse, on peut coller le lien entier (AgDR-0241, règle 3).
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { AideContact, Texte, Titre } from '../components/base';
import { enregistrerJeton, extraireJeton } from '../lib/jeton';
import { CollerLien } from './SansLien';

export function Invitation() {
  const { t } = useTranslation();
  const naviguer = useNavigate();
  const jeton = extraireJeton(window.location.hash);

  useEffect(() => {
    if (!jeton) return;
    enregistrerJeton(jeton);
    void naviguer('/', { replace: true });
  }, [jeton, naviguer]);

  if (jeton) return null;
  return (
    <section>
      <Titre>{t('lien.invalideTitre')}</Titre>
      <Texte>{t('lien.invalideTexte')}</Texte>
      <CollerLien onLien={() => void naviguer('/', { replace: true })} />
      <AideContact texte={t('lien.pasDeLien')} />
    </section>
  );
}
